import type { Ref } from 'react';
import { forwardRef } from 'react';

import type { TIconSize } from '../icon.interface';

const ProductExchangeIcon = forwardRef(
  ({ ...props }: TIconSize, ref: Ref<SVGSVGElement>) => {
    return (
      <svg
        width="32"
        height="32"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={ref}
        {...props}
      >
        <path
          d="M1.75 9.31872C1.75 8.56935 2.54379 8.08623 3.2094 8.43049L14 14.0115V28.4571L3.52297 23.0383C2.43491 22.4756 1.75 21.3419 1.75 20.1036V9.31872Z"
          fill="white"
        />
        <path
          d="M12.523 2.10502C12.9869 1.86508 13.4934 1.74512 14 1.74512C14.5066 1.74512 15.0131 1.86508 15.477 2.10502L24.5327 6.78866C25.2535 7.16147 25.2535 8.19232 24.5327 8.56512L14 14.0127L3.46736 8.56512C2.74656 8.19232 2.74656 7.16147 3.46736 6.78866L12.523 2.10502Z"
          fill="#E4E0FF"
        />
        <path
          d="M7.18817 9.48353L18.3757 3.69727L21.6762 5.40434L9.36987 11.7693V17.2507L6.36987 15.699V10.838C6.36987 10.2665 6.68598 9.74327 7.18817 9.48353Z"
          fill="#006DFF"
        />
        <path
          d="M24.7906 8.43049C25.4562 8.08623 26.25 8.56935 26.25 9.31872V17.6085C25.4148 17.218 24.4829 16.9998 23.5 16.9998C19.9101 16.9998 17 19.91 17 23.4998C17 24.5103 17.2306 25.467 17.642 26.32L14 28.2037V14.0115L24.7906 8.43049Z"
          fill="#C0AAFE"
        />
        <path
          d="M3.69478 20.5674C3.85326 20.2607 4.23032 20.1406 4.53697 20.2991L6.49697 21.3121C6.80361 21.4706 6.92372 21.8476 6.76524 22.1543C6.60675 22.4609 6.22969 22.581 5.92305 22.4226L3.96305 21.4096C3.6564 21.2511 3.5363 20.874 3.69478 20.5674Z"
          fill="#0F3893"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.1624 1.44611C13.315 0.849996 14.685 0.849996 15.8376 1.44611L24.8376 6.10098C26.1659 6.78797 27 8.1585 27 9.6539V18.0218C26.5368 17.7253 26.0335 17.4859 25.5 17.3135V9.6539C25.5 9.37362 25.4531 9.10035 25.3651 8.84351C25.2252 9.00214 25.0517 9.14004 24.8445 9.24719L15.8376 13.9057C15.4908 14.085 15.1243 14.2104 14.75 14.2818V27.386C14.8862 27.3432 15.0195 27.2884 15.1485 27.2217L17.5004 26.0053C17.6952 26.4714 17.9429 26.91 18.2358 27.3137L15.8376 28.554C14.685 29.1501 13.315 29.1501 12.1624 28.554L3.1624 23.8991C1.83414 23.2121 1 21.8416 1 20.3462V9.6539C1 8.1585 1.83414 6.78797 3.1624 6.10098L12.1624 1.44611ZM15.1485 2.77845C14.4282 2.40588 13.5718 2.40588 12.8515 2.77845L3.8515 7.43333L3.84452 7.43696C3.65062 7.53725 3.65062 7.81456 3.84452 7.91484L12.8515 12.5733C13.5718 12.9459 14.4281 12.9459 15.1485 12.5733L24.1554 7.91484C24.3493 7.81456 24.3493 7.53722 24.1554 7.43693L24.1485 7.43333L15.1485 2.77845ZM2.5 9.6539C2.5 9.37363 2.54688 9.10038 2.63491 8.84356C2.77476 9.00217 2.94826 9.14004 3.15542 9.24719L12.1624 13.9057C12.5092 14.085 12.8757 14.2104 13.25 14.2818V27.386C13.1138 27.3432 12.9805 27.2884 12.8515 27.2217L3.8515 22.5668C3.02134 22.1374 2.5 21.2808 2.5 20.3462V9.6539Z"
          fill="#0F3893"
        />
        <circle cx="23.5" cy="23.5" r="7.5" fill="#006DFF" />
        <path
          d="M24.5581 19.0581C24.8021 18.814 25.1979 18.814 25.4419 19.0581L27.1919 20.8081C27.2528 20.8689 27.2985 20.9392 27.329 21.0143C27.3584 21.0864 27.3747 21.1653 27.375 21.248L27.375 21.25L27.375 21.252C27.3745 21.4161 27.3107 21.5654 27.2068 21.6766C27.2014 21.6824 27.1959 21.6881 27.1902 21.6936L25.4419 23.4419C25.1979 23.686 24.8021 23.686 24.5581 23.4419C24.314 23.1979 24.314 22.8021 24.5581 22.5581L25.2411 21.875H20.25C19.9048 21.875 19.625 21.5952 19.625 21.25C19.625 20.9048 19.9048 20.625 20.25 20.625H25.2411L24.5581 19.9419C24.314 19.6979 24.314 19.3021 24.5581 19.0581Z"
          fill="white"
        />
        <path
          d="M22.4419 23.5581C22.686 23.8021 22.686 24.1979 22.4419 24.4419L21.7589 25.125H26.75C27.0952 25.125 27.375 25.4048 27.375 25.75C27.375 26.0952 27.0952 26.375 26.75 26.375H21.7589L22.4419 27.0581C22.686 27.3021 22.686 27.6979 22.4419 27.9419C22.1979 28.186 21.8021 28.186 21.5581 27.9419L19.8081 26.1919C19.564 25.9479 19.564 25.5521 19.8081 25.3081L21.5581 23.5581C21.8021 23.314 22.1979 23.314 22.4419 23.5581Z"
          fill="white"
        />
      </svg>
    );
  }
);

export default ProductExchangeIcon;
